import React from 'react';
import { InputText, type InputTextProps } from './InputText/InputText';

type InputZipProps = Omit<
  InputTextProps,
  | 'autoCapitalize'
  | 'autoComplete'
  | 'autoCorrect'
  | 'dataDetectorTypes'
  | 'keyboardType'
  | 'multiline'
  | 'numberOfLines'
  | 'onContentSizeChange'
  | 'passwordRules'
  | 'rightIconProps'
  | 'scrollEnabled'
  | 'secureTextEntry'
  | 'textContentType'
>;

export const InputZip = ({
  accessibilityLabel,
  autoFocus,
  backgroundColor,
  blurOnSubmit,
  caption,
  defaultValue,
  disabled,
  error,
  hideClearButton,
  label,
  leftIconProps,
  maxLength,
  onBlur,
  onChangeText,
  onFocus,
  onKeyPress,
  onRef,
  onSubmitEditing,
  optional,
  placeholder,
  required,
  returnKeyType,
  sublabel,
  testID,
  value,
}: InputZipProps) => {
  return (
    <InputText
      accessibilityLabel={accessibilityLabel || 'Zip'}
      autoCapitalize="none"
      autoComplete="postal-code"
      autoCorrect={false}
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus={autoFocus}
      backgroundColor={backgroundColor}
      blurOnSubmit={blurOnSubmit}
      caption={caption}
      defaultValue={defaultValue}
      disabled={disabled}
      error={error}
      hideClearButton={hideClearButton}
      keyboardType="number-pad"
      label={label}
      leftIconProps={leftIconProps}
      maxLength={maxLength}
      onBlur={onBlur}
      onChangeText={onChangeText}
      onFocus={onFocus}
      onKeyPress={onKeyPress}
      onRef={onRef}
      onSubmitEditing={onSubmitEditing}
      optional={optional}
      placeholder={placeholder || '20252'}
      required={required}
      returnKeyType={returnKeyType}
      sublabel={sublabel}
      testID={testID}
      textContentType="postalCode"
      value={value}
    />
  );
};
